<app-base-dialog headerText="Edit Playlist" [dismissOverride]="dismissFunction">
  <div class="modal-body" *ngIf="playlistId">
    <app-playlist-manage
      [invokedFrom]="'channelPage'"
      [inlinePlaylistId]="playlistId"
    ></app-playlist-manage>
  </div>
</app-base-dialog>
